/**
 * Created by JackCui on 2022/9/27
 */

import {assign} from 'lodash-es'
import {schemaHandle} from '../../schema-config'
import {PAAS_REG} from 'fe-coms-share/paas/constants'

export const quoteSchemaHandle = {
  handle (node, store) {
    const {pageType, layoutApiName, quoteFieldsMap} = store
    const fields = quoteFieldsMap?.[node.relateObjectApiName] || []
    const relateField = {
      type: node.relateFieldType,
      _type: node.relateFieldType?.replace(PAAS_REG, ''),
      props: {},
      isPureText: true,
      ...fields.find(v => v.apiName === node.relateFieldApiName)
    }
    const fieldConfig = schemaHandle[relateField._type + 'SchemaHandle']
    if (fieldConfig?.handle) {
      assign(relateField, fieldConfig.handle(relateField, store))
    }
    const params = {
      relateNode: relateField,
      quoteNode: node,
      objectApiName: node.objectApiName,
      layoutApiName,
      // 引用能力的code
      relatePowerCode: node.relatePowerCode,
      // 引用对象的apiName
      relateObjectApiName: node.relateObjectApiName,
      relateFieldApiName: node.relateFieldApiName,
      relateFieldType: node.relateFieldType,
      // 是否需要单独请求查询值的接口
      resInterfaces: pageType === 'edit'
    }

    return {
      props: {
        ...node.props,
        params,
        isPureText: true
      }
    }
  }
}

export const QuoteProps = {
  value: {
    type: String,
    default: ''
  },
  isPureText: {
    type: Boolean,
    default: false
  },
  // 查找关联额外参数
  params: {
    type: Object,
    default: () => ({})
  },
  // 租户类型
  tenantType: {
    type: String,
    default: 'pur'
  },
  row: {
    type: Object
  },
  rowIndex: {
    type: Number
  },
  // 行数据 id
  id: {
    type: String,
    default: ''
  }
}
 